var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('title-view',[_vm._v("מסך כרטיסים "),_c('v-btn',{attrs:{"slot":"actions","color":"success"},on:{"click":_vm.exportExcel},slot:"actions"},[_vm._v("דו\"ח כרטיסים")])],1),_c('row',[_c('c-col',[_c('cards-table')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }